__turbopack_context__.v({
  "base": "gREiba_base",
  "button": "gREiba_button",
  "withQuantity": "gREiba_withQuantity",
  "wrapper": "gREiba_wrapper",
});
